import { render, staticRenderFns } from "./Scientific_industry.vue?vue&type=template&id=0abba3f9&scoped=true"
import script from "./Scientific_industry.vue?vue&type=script&lang=js"
export * from "./Scientific_industry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abba3f9",
  null
  
)

export default component.exports